import { isNumber } from '@/helpers/common';

export default {
  validate: (value) => {
    return {
      required: true,
      valid: (value || value === 0) && isNumber(value),
    };
  },
  message: 'Please enter a number e.g. 1000.',
  computesRequired: true,
};
